import React, { Component } from 'react';
import { getParam } from './../../redux/helpers/getParams';

class Debugger extends Component {
  constructor(args) {
    super(args);
    this.state = {
      hidden: true,
    };
  }

  componentDidMount() {
    if (getParam('debug')) {
      this.setHidden();
    }
  }

  setHidden = () => {
    this.setState({
      hidden: false,
    });
  }

  renderInfo = () => {
    const { props } = this;
    let info = '';
    for (const key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key)) {
        info += `${key}: ${props[key]}\n`;
      }
    }

    return info;
  }


  render() {
    const { hidden } = this.state;

    if (hidden) {
      return (
        <div />
      );
    }

    return (
      <div className="debugger-info" >
        <p>{this.renderInfo()}</p>
      </div>
    );
  }
}

export default (Debugger);



// WEBPACK FOOTER //
// ./src/components/debugger/Debugger.jsx